import React from "react";

const CategoryCard = ({
  category,
  isSelected,
  onSelect,
  title,
  description,
}) => {
  return (
    <div
      onClick={() => onSelect(category.id)}
      className={`flex items-stretch border rounded-lg cursor-pointer transition-transform duration-300 shadow-sm hover:shadow-lg ${
        isSelected
          ? "border-primary bg-primary/10 scale-105"
          : "border-gray-300 bg-white hover:scale-105"
      }`}
    >
      {/* Image */}
      <div className="w-1/4 h-32 overflow-hidden rounded-l-lg">
        <img
          src={category.imageUrl}
          alt={category.name}
          className="w-full h-full object-cover"
          loading="lazy"
        />
      </div>

      {/* Content */}
      <div className="flex-1 flex flex-col justify-center px-3 py-2">
        <h3 className="font-bold text-lg text-gray-800 leading-tight">
          {title}
        </h3>
        <p className="text-gray-500 text-sm mt-1 leading-snug">{description}</p>
      </div>

      {/* Checkbox */}
      <div className="flex items-center pr-4">
        <div
          className={`w-6 h-6 rounded-full border-2 flex items-center justify-center transition-all duration-300 ${
            isSelected ? "bg-primary border-primary" : "border-gray-300"
          }`}
        >
          {isSelected && (
            <svg
              className="w-4 h-4 text-white"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M5 13l4 4L19 7"
              />
            </svg>
          )}
        </div>
      </div>
    </div>
  );
};

export default CategoryCard;
